export const SUPER_ADMIN   = 100;
export const ADMIN   = 0;
export const SALE   = 1;
export const FINANCIAL   = 2;
export const ADMINOP6   = 3;
export const AGENT   = 10;
export const AGENTOP6   = 13;